import { Injectable } from '@angular/core';
import {Http, Headers, Response} from "@angular/http";
import 'rxjs/add/operator/map';
import {BaseService} from "./base-service";
import {Observable} from "rxjs";
import {AppConfig} from "../config/appconfig";
import { Storage } from '@ionic/storage';
import {MonitoringObjectContainer} from "../infrastructure/MonitoringObjectContainer";
import {UserInfoSingleton} from "../infrastructure/UserInfoSingleton";

/*
  Generated class for the UserService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class UserService extends BaseService{

  private isLoggedin: boolean = false;

  private readonly registerUrl: string = AppConfig.apiBaseUrl + "register";

  private readonly getUserInfoUrl: string = AppConfig.apiBaseUrl + "userinfo";

  private readonly updateUserUrl : string = AppConfig.apiBaseUrl + "updateuser";

  private readonly changePwdUrl : string = AppConfig.apiBaseUrl + "changepwd";

  constructor(
    public http: Http,
    protected storage: Storage
  ) {
    super(http, storage);

    if(this.token){
      this.isLoggedin = true;
    }
  }

  public get userLogin(): string{
    //return window.localStorage.getItem('access-login');
    return this.userName;
  }

  public get IsLoggedIn():boolean{
    //return this.isLoggedin;
    return this.token !== null && this.token !== undefined;
  }


  public login(user: any): Observable<boolean> {
    //user.grant_type = "password";

    let creds = `email=${user.email}&password=${user.password}&grant_type=password`;

    let operation:Observable<Response> = this.http.post(
      AppConfig.loginUrl,
      creds,
      this.loginHeaders
    );

      return operation.map((res:Response) =>
      {
        let body = res.json();
        let d = body || {};
        this.token = d.access_token;
        this.userName = user.email;

        this.isLoggedin = true;
        return this.isLoggedin;
      });
    //   .catch((err) => {
    //     console.log(err);
    //     return Observable.throw(err);
    // });
  }

  public checkPass(user: any): Observable<boolean> {
    let creds = `email=${user.email}&password=${user.password}&grant_type=password`;

    let operation:Observable<Response> = this.http.post(
      AppConfig.loginUrl,
      creds,
      this.loginHeaders
    );

    return operation.map((res:Response) =>
    {
      let body = res.json();
      return this.isLoggedin;
    });
  }

  public authnticate(user: any){
    window.localStorage.setItem('access-token', user.access_token);
    window.localStorage.setItem('access-login', user.email);
  }

  public logout(): Observable<any> {
    return Observable.create(observer => {
      console.log('Logging out');
      this.isLoggedin = false;
      window.localStorage.clear();
      window.sessionStorage.clear();

      if(MonitoringObjectContainer.Instance) {
        MonitoringObjectContainer.Instance.clear();
      }

      if(UserInfoSingleton.instance) {
        UserInfoSingleton.instance.clear();
      }

      try {
        if(this.storage) {
          this.storage.clear()
            .then(() => {
              observer.next(true);
              observer.complete();
            })
            .catch(err => {
              console.log(err);
              throw Observable.throw(err);
            });
        }
      }
      catch(e){
        throw Observable.throw(e);
      }
    });
  }

  public register(user: any): Observable<boolean> {
    let headers = new Headers();
    //headers.append('Content-Type', 'application/x-www-form-urlencoded');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');

    return this.http.post(
      this.registerUrl,
      user,
      {headers: headers}
    )
      .map((res:Response) =>
      {
        // let body = res.json();
        // let d = body || {};

        // this.isLoggedin = true;
        return true;
      });
    //.catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  changePassword(user: any): Observable<boolean> {
        return this.http.post(
      this.changePwdUrl,
      user,
          {headers: this.headers}
    )
      .map((res:Response) =>
      {
         return true;
      });
  }

  public updateUser(user: any): Observable<boolean> {
    return this.http.post(
      this.updateUserUrl,
      user,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        // let body = res.json();
        // let d = body || {};

        // this.isLoggedin = true;
        return true;
      });
    //.catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  // AS: получение инфы о пользователе
  public getInfo(): Observable<any>{
    return this.http.get(
      this.getUserInfoUrl,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let body = res.json();
        let d = body || {};
        return d;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/user-service.ts